// Shared drag-and-drop and upload helpers used across builder editor and element controllers.

export function isFileDrag(e) {
  const dataTransfer = e.dataTransfer
  if (!dataTransfer) return false

  const items = dataTransfer.items
  if (items && Array.from(items).some((item) => item.kind === 'file'))
    return true
  if (dataTransfer.files && dataTransfer.files.length > 0) return true

  const types = dataTransfer.types
  return types && Array.from(types).includes('Files')
}

// The active picker and the legacy uploader share the manual-upload event.
export function triggerManualUpload(files, attempt = 0) {
  const target =
    document.querySelector(
      '[data-controller~="media--dialog"]:not([data-media-dialog-closed]) [data-controller~="media--upload"]'
    ) || document.querySelector('#fileupload.s3-multipart-uploader')
  if (target)
    return target.dispatchEvent(
      new CustomEvent('manual-upload', { detail: { files } })
    )
  if (attempt < 20)
    setTimeout(() => triggerManualUpload(files, attempt + 1), 50)
  else
    console.error(
      '[builder] triggerManualUpload: uploader form not found after polling — upload aborted'
    )
}
